import type { LeadFieldsPatch } from '@viq-admin/screens';
import type { LeadFieldsUpdateResponse } from '@viq-admin/types';
import { adminFetch } from './dataProvider';

/**
 * PATCH /v1/admin/leads/:id/fields — the Batch grid's inline edit (viq-vault
 * spec 2026-09-17, viq-backend#117). Sends only the fields being changed;
 * per-field last-write-wins, so no `expectedVersion`, and never
 * `displayName` (the server derives it from first + last and 400s the key).
 * Server gate: `adminAuth({ roles: ['company_admin'] })`, one write token per
 * call.
 *
 * The 200 `lead` is the updated row in list-row shape plus `completeness` /
 * `crmSentAt`, which the shared grid merges straight into the row. Errors are
 * `fetchJson`'s HttpError, untouched: `statusCode`, `message`, `errors` (the
 * 400's field errors) and `retryAfter` on a 429, which the grid's sync store
 * reads to decide whether and when to retry.
 */
export function patchLeadFields(
  leadId: string,
  patch: LeadFieldsPatch,
): Promise<LeadFieldsUpdateResponse> {
  return adminFetch<LeadFieldsUpdateResponse>(`/v1/admin/leads/${leadId}/fields`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}
